<mat-form-field appearance="outline">
  <mat-label>Sort By</mat-label>
  <mat-select [(ngModel)]="value" (ngModelChange)="onValueChanged()">
    @for (option of options; track $index) {
    <mat-option [value]="option.value">{{option.name}}</mat-option>
    }
  </mat-select>
</mat-form-field>
